import { AbstractControl, ValidatorFn } from "@angular/forms";
import { Regex } from "./keys";

export default class FormValidators {

    static noWhitespaceValidator(): ValidatorFn {

        return (control: AbstractControl) => {
            const isWhitespace = (control.value || '').trim().length === 0;
            return !isWhitespace ? null : { whitespace: true };
        };

    };

    static cidrValidator(): ValidatorFn {

        return (control: AbstractControl) => {

            if (control.value && !new RegExp(Regex.cidrBlock).test(control.value)) {
                return { invalidCidr: true };
            }

            return null;
        };

    };


}